import React from 'react';

const CheckboxFilledIcon = () => {
    return (
        <svg viewBox="0 0 16 16" width="17px" height="17px">
            <g clipPath="url(#clip0_265_16460)">
                <rect width="16" height="16" rx="4" fill="currentColor" />
                <path
                    d="M6.25136 10.0642C5.98595 10.3113 5.55588 10.3112 5.2906 10.064L3.35003 8.25526C3.08533 8.00854 2.65639 8.00783 2.39075 8.25368L2.36772 8.27499C2.10075 8.52207 2.09999 8.9243 2.36602 9.17225L5.29037 11.8979C5.55574 12.1452 5.98599 12.1452 6.25136 11.8979L13.6346 5.01629C13.9 4.76896 13.9 4.36795 13.6346 4.12061L13.6149 4.10225C13.3497 3.855 12.9196 3.8549 12.6542 4.10204L6.25136 10.0642Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_265_16460">
                    <rect width="16" height="16" rx="4" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default CheckboxFilledIcon;